import React, { ReactElement } from 'react';

import { IMaybeParentProps } from '../../../shared/types/IMaybeParentProps';
import { IQATestableProps } from '../../../shared/types/IQATestableProps';
import { OzSkeletonBox } from '../../skeleton-box/SkeletonBox';
import productCardStyles from '../OzProductCard.module.css';
import { PRODUCT_CARD_VARIANTS } from '../PRODUCT_CARD_VARIANTS';

import styles from './OzSkeletonProductCard.module.css';

export type ISkeletonProductCardProps = IMaybeParentProps & IQATestableProps & {
    variant: PRODUCT_CARD_VARIANTS;
};

export function OzSkeletonProductCard (props: ISkeletonProductCardProps): ReactElement {
    const {
        'data-testid': dataTestId,
        variant,
        children,
    }: ISkeletonProductCardProps = props;

    if (variant === PRODUCT_CARD_VARIANTS.FLOATING) {
        return (
            <div data-testid={dataTestId}>
                <div className="aspect-video relative mb-1/2">
                    <OzSkeletonBox className="absolute inset-0" />
                </div>
                <OzSkeletonBox className={`${styles['text-line']} mb-1/2`} />
                <OzSkeletonBox className={`${styles['text-line']} mb-1/2`} />
                <OzSkeletonBox className={`${styles['text-line']}`} />
                {children}
            </div>
        );
    }

    return (
        <div data-testid={dataTestId} className={`${productCardStyles.contained} overflow-hidden bg-white-500`}>
            <div className="aspect-video mb-1/2 relative">
                <OzSkeletonBox className="absolute inset-0" />
            </div>
            <div className="p-2">
                <OzSkeletonBox className={`${styles['text-line']} mb-1/2`} />
                <OzSkeletonBox className={`${styles['text-line']} mb-1/2`} />
                <OzSkeletonBox className={`${styles['text-line']}`} />
                {children}
            </div>
        </div>
    );
}
